import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import axios from 'axios';

const PruebasSinCorregirWidget = () => {
  const navigate = useNavigate();
  const { user, API } = useContext(AuthContext);
  const [data, setData] = useState({ clases: [], total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && (user.rol === 'profesor' || user.rol === 'admin')) {
      loadSinCorregir();
    } else {
      setLoading(false);
    }
  }, [user]);

  const loadSinCorregir = async () => {
    try {
      const response = await axios.get(`${API}/pruebas-examenes/sin-corregir`);
      setData(response.data || { clases: [], total: 0 });
    } catch (error) {
      console.error('Error al cargar pruebas sin corregir:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || data.total === 0) return null;

  const handleClick = () => {
    navigate('/app/pruebas-examenes');
  };

  return (
    <div
      onClick={handleClick}
      className="group relative bg-gradient-to-br from-red-500 via-rose-500 to-orange-500 rounded-2xl cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl overflow-hidden h-56"
      data-testid="pruebas-sin-corregir-widget"
    >
      {/* Shine effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />

      {/* Pulsing alert dot */}
      <div className="absolute top-3 right-3 z-20">
        <div className="relative">
          <div className="absolute inset-0 bg-white rounded-full animate-ping opacity-40" />
          <div className="relative bg-white text-red-600 rounded-full w-10 h-10 flex items-center justify-center text-lg font-black shadow-lg">
            {data.total}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col p-5 text-white">
        {/* Header */}
        <div className="flex items-center gap-2 mb-3">
          <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
            <i className="fas fa-pen-fancy text-xl" />
          </div>
          <div>
            <p className="text-xs font-medium opacity-80">Pendiente</p>
            <p className="text-sm font-bold">Por Corregir</p>
          </div>
        </div>

        {/* Classes list */}
        <div className="flex-1 overflow-hidden space-y-1">
          {data.clases.slice(0, 3).map((clase) => (
            <div key={clase.clase_id} className="flex items-center justify-between bg-white/15 rounded-lg px-2 py-1 backdrop-blur-sm">
              <span className="text-xs font-medium truncate flex-1 mr-2">
                {clase.clase_titulo}
              </span>
              <span className="text-xs font-bold bg-white/25 rounded-full px-2 py-0.5 shrink-0">
                {clase.total_sin_corregir}
              </span>
            </div>
          ))}
          {data.clases.length > 3 && (
            <p className="text-xs opacity-70 text-center">
              +{data.clases.length - 3} clases mas...
            </p>
          )}
        </div>

        {/* Footer */}
        <div className="mt-auto pt-2 border-t border-white/20">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold opacity-90">
              {data.total} {data.total === 1 ? 'respuesta' : 'respuestas'} sin corregir
            </span>
            <span className="text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <i className="fas fa-arrow-right mr-1" />
              Corregir
            </span>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16" />
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12" />
    </div>
  );
};

export default PruebasSinCorregirWidget;
